(function () {
    'use strict';

    var wizardStepNex = {
        transclude: true,
        templateUrl: 'app/components/wizard/wizard-step-next.html',
        controller: wizardStepNexController,
        controllerAs: 'vm',
        require: {
            'parent': '^wizard'
        },
        bindings:{
            label: '@',
            formWizard: '='
        }
    }

    angular
        .module('completeAir')
        .component('wizardStepNex', wizardStepNex);

    function wizardStepNexController(){
        var vm = this;
        vm.$onInit = function(){
        }

        vm.disabledNext = function() {
            vm.parent.disabledNext();
        }

        vm.nextWizard = function() {
            vm.wizardStepCurrent = vm.parent.wizardStep + 1;
            vm.parent.nextWizard(vm.wizardStepCurrent);
        }
    }

})();

